import type { FluxErrorEntityErrorCodeValue } from '../types.js';

export type ExtractedMessages<T extends Record<string, FluxErrorEntityErrorCodeValue<any>>> = {
  [K in keyof T as T[K] extends { code: infer C } ? (C extends string ? C : K) : K]: T[K];
};

/**
 * Helper function to map an object of error definitions to an object keyed by error codes.
 */
export function extractMessages<T extends Record<string, FluxErrorEntityErrorCodeValue<any>>>(obj: T): ExtractedMessages<T> {
  return Object.fromEntries(
    Object.entries(obj).map(([, value]) => {
      if (!value?.code) throw new Error('Invalid error definition: missing code property');
      return [value.code, value];
    }),
  ) as ExtractedMessages<T>;
}
